import React from 'react';
import { Row, Col, Image } from 'react-bootstrap';
import emet from 'assets/img/logos/emet.png';
import epst from 'assets/img/logos/epst.png';
import certified from 'assets/img/logos/certified.png';

import LoginForm from 'pages/login/LoginForm';

/**
 * LoginCard component
 *
 * Tarjeta central de la página de login que muestra:
 * - Logo principal de Instituto CertifiED
 * - Formulario de login
 * - Logos de certificaciones EMET y EPST
 *
 * @component
 * @returns {JSX.Element} Tarjeta con logos y formulario de inicio de sesión
 */
const LoginCard = () => {
	return (
		<>
			<Row className="mb-5 text-center">
				<Col>
					<Image
						src={certified}
						alt="Instituto Certified"
						style={{ width: '100px', height: '100px' }}
					/>
				</Col>
			</Row>

			<LoginForm layout="card" hasLabel />

			<Row className="mt-5 text-center">
				<Col>
					<Image
						src={emet}
						alt="Certificación EMET"
						style={{ width: '80px', height: '80px' }}
					/>
				</Col>
				<Col>
					<Image
						src={epst}
						alt="Certificación EPST"
						style={{ width: '80px', height: '80px' }}
					/>
				</Col>
			</Row>
		</>
	);
};

export default LoginCard;